import jsonConfig from '../config.json'
const config = jsonConfig;
export const urlAmazon = "https://s3.amazonaws.com/";
export const statusOk = "OK";
export const statusError = "ERROR";
export const status200 = 200;
export const backgroundColor = "#701a82";
export const identityFrontUrl = config.IDENTITY_FRONT_URL || 'https://firma.id.autofact.qa/';
export const API_URL = config.REACT_APP_ENV_API_URL || "https://eskshdl1gi.execute-api.us-east-1.amazonaws.com/latest/v1/rekognition/";
export const errors = {
    CODE_NOT_FOUND: 'CODE_NOT_FOUND'
}